export default __webpack_public_path__ + "static/img_process-d2911f2cf47cb717fbd6f275fe865acb.png";